export function blobToString(blob: Blob): Promise<string> {
    return new Promise<string>((res, rej) => {
        const reader = new FileReader();
        reader.addEventListener("loadend", () => res(reader.result as string));
        reader.addEventListener("abort", () => rej());
        reader.addEventListener("error", () => rej());
        reader.readAsText(blob, "utf8");
    });
}
